import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
    lng: "en",
    fallbackLng: "en",
    interpolation: {
        escapeValue: false,
    },
    resources:{
        en: {
            translation: {
                title: 'CineFX',
                ciao: "Hi",
                account: "Account",
                manageabbonamento: "Manage your profile and subscription.",
                yourprofile: "Your profile",
                yoursubscription: "Your subscription",
                youdonthavesubscription: "You don't have a subscription yet.",
                subscribelabel: "Subscribe to access all features without limits.",
                subscribe: "Subscribe",
                accountpromotitle: "Unlock all of CineFX",
                accountpromosubtitle: "No limits, no compromises on set.",
                promobenefit1title: "300+ cameras and 3000+ lenses",
                promobenefit1subtitle: "Full library, always up to date",
                promobenefit2title: "Every tool unlocked",
                promobenefit2subtitle: "All professional calculators, no restrictions",
                promobenefit3title: "Unlimited use",
                promobenefit3subtitle: "No cap on calculations",
                promobenefit4title: "Updates included",
                promobenefit4subtitle: "New tools and cameras as they ship",
                name: "Name",
                surname: "Surname",
                email: "Email",
                uid: "UID",
                status: "Status",
                active: "Active",
                startsubscription: "Subscription start",
                nextrenew: "Next renewal",
                frequency: "Frequency",
                annualprice: "Annual price",
                invoices: "INVOICES",
                invoicenumber: "Invoice number",
                date: "Date",
                price: "Amount",
                downloadinvoice: "Download invoice",
                indata: "On",
                hairichiestoannullamento: "you have requested the cancellation of your subscription.",
                subscriptionwillbeinterruptedon: "The subscription will be interrupted on",
                restoresubscriptionquestion: "Restore the subscription?",
                restoresubscription: "Restore subscription",
                deletesubscriptionquestion: "Cancel the subscription?",
                deletesubscription: "Cancel subscription",
                cancelled: "Cancelled",
                ended: "Ended",
                notavailable: "N/A",
                emailplaceholder: "name@email.com",
                password: "Password",
                login: "Login",
                passwordforgot: "Forgot password",
                orcontinuewith: "or continue with",
                developedby: "developed by",
                logout: "Logout",
                logoutdialogtitle: "Log out?",
                logoutdialogdescription: "You'll need to sign in again to manage your subscription.",
                back: "Back",
                resetpsw: "Reset password",
                emailsent: "We have sent you an email with instructions to reset your password",
                backtologin: "Back to login",
                alreadyhavesub: "You already have a subscription.",
                backtoaccount: "Back to your account",
                backtoapp: "Back to the app",
                cart: "Cart",
                product: "Product",
                type: "Type",
                subscription: "Subscription",
                annual: "Annual",
                pricefirstyear: "Price for the first year",
                emailcinefxaccount: "CineFX account email",
                cinefx: "CineFX",
                topaytoday: "Total to pay today",
                subrenewsat: "The subscription renews automatically at",
                youcancancelanytime: "You can cancel anytime. See",
                termsandconditions: "Terms and Conditions",
                paymentmethod: "Payment method",
                declareto: "By clicking on Pay, you declare that you have read and agree to the",
                andthe: "and the ",
                privacypolicy: "Privacy Policy",
                declareautorenew: " You confirm you want to activate a subscription that renews automatically every year at {{price}}, unless you cancel it before the renewal date.",
                declareautorenewfallback: " You confirm you want to activate a subscription that renews automatically every year, unless you cancel it before the renewal date.",
                pay: "PAY",
                paymentintenterror: "We couldn't start the checkout. Please try again.",
                discountbadge: "{{percent}}% off the first year",
                billingdetails: "Billing details",
                billingdetailssubtitle: "Used for your invoices — works for any country.",
                taxidrequired: "VAT / Tax ID",
                taxidrequirederror: "VAT / Tax ID is required to issue an invoice.",
                taxidplaceholder: "e.g. IT01234567890",
                sdicodeoptional: "SDI code (optional, Italian companies)",
                sdicodeplaceholder: "e.g. 0000000 or PEC-based code",
                vat: "Tax code",
                country: "Country",
                city: "City",
                address: "Address",
                streetnumber: "Street number",
                next: "Next",
                paymentcompleted: "Payment completed",
                paymentcompletedlabel: "Your payment was successful.",
                paymentmethodexpiredtitle: "Your payment method needs to be updated",
                paymentmethodexpiredlabel: "Your payment method appears to be expired or expiring before your next subscription renewal.",
                updatepaymentmethod: "Update payment method",
                redirectingtostripe: "Redirecting to Stripe",
                redirectingtostripelabel: "We are opening Stripe's secure page to update your payment method.",
                unabletoredirect: "Unable to complete the redirect",
                retry: "Try again",
                updatepaymentmethodlinkerror: "An error occurred while creating the link to update the payment method.",
                stripelinknotavailable: "The Stripe link is not available.",
                genericerror: "An unexpected error occurred.",
                usernotauthenticated: "User not authenticated.",
                canceldialogtitle: "Cancel your subscription?",
                canceldialogdescription: "It's free, no hidden costs. You'll keep full access until the end of the period you already paid for — {{date}}. You can come back and resubscribe anytime.",
                canceldialogconfirm: "Yes, cancel subscription",
                closelabel: "Close",
                subscriptioncancelledsuccess: "Your subscription has been cancelled. You'll keep access until the end of the current period.",
                restoredialogtitle: "Restore your subscription?",
                restoredialogdescription: "Your subscription will keep renewing automatically as before.",
                restoredialogconfirm: "Yes, restore subscription",
                subscriptionrestoredsuccess: "Your subscription has been restored.",
            }
        },
        it: {
            translation: {
                title: 'CineFX',
                ciao: "Ciao",
                account: "Account",
                manageabbonamento: "Gestisci il tuo profilo e il tuo abbonamento.",
                yourprofile: "Il tuo profilo",
                yoursubscription: "Il tuo abbonamento",
                youdonthavesubscription: "Non hai ancora un abbonamento.",
                subscribelabel: "Per usufruire di tutte le funzionalità senza limiti, abbonati.",
                subscribe: "Abbonati",
                accountpromotitle: "Sblocca tutto CineFX",
                accountpromosubtitle: "Nessun limite, nessun compromesso sul set.",
                promobenefit1title: "300+ camere e 3000+ ottiche",
                promobenefit1subtitle: "Libreria completa, sempre aggiornata",
                promobenefit2title: "Tutti i tool sbloccati",
                promobenefit2subtitle: "Ogni calcolatore professionale, senza restrizioni",
                promobenefit3title: "Utilizzo illimitato",
                promobenefit3subtitle: "Nessun tetto ai calcoli",
                promobenefit4title: "Aggiornamenti inclusi",
                promobenefit4subtitle: "Nuovi tool e camere via via che arrivano",
                name: "Nome",
                surname: "Cognome",
                email: "Email",
                uid: "UID",
                status: "Status",
                active: "Attivo",
                startsubscription: "Inizio abbonamento",
                nextrenew: "Prossimo rinnovo",
                frequency: "Frequenza",
                annualprice: "Prezzo annuale",
                invoices: "FATTURE",
                invoicenumber: "Numero fattura",
                date: "Data",
                price: "Importo",
                downloadinvoice: "Scarica la fattura",
                indata: "In data",
                hairichiestoannullamento: "hai richiesto la cancellazione dell'abbonamento.",
                subscriptionwillbeinterruptedon: "L'abbonamento verrà interrotto il",
                restoresubscriptionquestion: "Ripristinare l'abbonamento?",
                restoresubscription: "Ripristina abbonamento",
                deletesubscriptionquestion: "Annullare l'abbonamento?",
                deletesubscription: "Annulla abbonamento",
                cancelled: "Cancellato",
                ended: "Terminato",
                notavailable: "N/A",
                emailplaceholder: "nome@email.com",
                password: "Password",
                login: "Accedi",
                passwordforgot: "Ho dimenticato la password",
                orcontinuewith: "oppure continua con",
                developedby: "sviluppata da",
                logout: "Esci",
                logoutdialogtitle: "Uscire dall'account?",
                logoutdialogdescription: "Dovrai accedere di nuovo per gestire il tuo abbonamento.",
                back: "Indietro",
                resetpsw: "Reimposta password",
                emailsent: "Ti abbiamo inviato una mail con le istruzioni per il reset della password",
                backtologin: "Torna al login",
                alreadyhavesub: "Hai già un abbonamento.",
                backtoaccount: "Torna al tuo account",
                backtoapp: "Torna all'app",
                cart: "Carrello",
                product: "Prodotto",
                type: "Tipo",
                subscription: "Abbonamento",
                annual: "Annuale",
                pricefirstyear: "Prezzo per il primo anno",
                emailcinefxaccount: "Email account CineFX",
                cinefx: "CineFX",
                topaytoday: "Totale da pagare oggi",
                subrenewsat: "L'abbonamento di rinnova in automatico a",
                youcancancelanytime: "Puoi disdire quando vuoi. Si applicano",
                termsandconditions: "Termini e Condizioni",
                paymentmethod: "Metodo di pagamento",
                declareto: "Cliccando su Paga, dichiari di aver letto e accettato i",
                andthe: "e l'",
                privacypolicy: "Informativa sulla Privacy",
                declareautorenew: " Confermi di voler attivare un abbonamento a rinnovo automatico ogni anno a {{price}}, salvo disdetta prima della data di rinnovo.",
                declareautorenewfallback: " Confermi di voler attivare un abbonamento a rinnovo automatico ogni anno, salvo disdetta prima della data di rinnovo.",
                pay: "PAGA",
                paymentintenterror: "Non siamo riusciti ad avviare il pagamento. Riprova.",
                discountbadge: "-{{percent}}% il primo anno",
                billingdetails: "Dettagli di fatturazione",
                billingdetailssubtitle: "Usati per le tue fatture — validi per qualsiasi paese.",
                taxidrequired: "Partita IVA / Codice fiscale",
                taxidrequirederror: "Partita IVA / Codice fiscale obbligatorio per emettere fattura.",
                taxidplaceholder: "es. IT01234567890",
                sdicodeoptional: "Codice SDI (opzionale, aziende italiane)",
                sdicodeplaceholder: "es. 0000000 o codice basato su PEC",
                vat: "Codice fiscale",
                country: "Paese",
                city: "Città",
                address: "Indirizzo",
                streetnumber: "Civico",
                next: "Avanti",
                paymentcompleted: "Pagamento completato",
                paymentcompletedlabel: "Il tuo pagamento è andato a buon fine.",
                paymentmethodexpiredtitle: "Il metodo di pagamento deve essere aggiornato",
                paymentmethodexpiredlabel: "Il tuo metodo di pagamento risulta scaduto o in scadenza prima del prossimo rinnovo dell'abbonamento.",
                updatepaymentmethod: "Aggiorna metodo di pagamento",
                redirectingtostripe: "Reindirizzamento a Stripe in corso",
                redirectingtostripelabel: "Stiamo aprendo la pagina sicura di Stripe per aggiornare il tuo metodo di pagamento.",
                unabletoredirect: "Impossibile completare il reindirizzamento",
                retry: "Riprova",
                updatepaymentmethodlinkerror: "Errore durante la creazione del link per aggiornare il metodo di pagamento.",
                stripelinknotavailable: "Il link di Stripe non è disponibile.",
                genericerror: "Si è verificato un errore imprevisto.",
                usernotauthenticated: "Utente non autenticato.",
                canceldialogtitle: "Annullare l'abbonamento?",
                canceldialogdescription: "È gratis, nessun costo nascosto. Mantieni l'accesso completo fino alla fine del periodo già pagato — {{date}}. Puoi tornare e riabbonarti quando vuoi.",
                canceldialogconfirm: "Sì, annulla abbonamento",
                closelabel: "Chiudi",
                subscriptioncancelledsuccess: "Il tuo abbonamento è stato annullato. Manterrai l'accesso fino alla fine del periodo in corso.",
                restoredialogtitle: "Ripristinare l'abbonamento?",
                restoredialogdescription: "Il tuo abbonamento tornerà a rinnovarsi automaticamente come prima.",
                restoredialogconfirm: "Sì, ripristina abbonamento",
                subscriptionrestoredsuccess: "Il tuo abbonamento è stato ripristinato.",
            }
        },
    }
});

export default i18n;